import { useEffect, useState } from 'react';
import { PageTitle } from '../../../_metronic/layout/core';
import styleScss from './styles.module.scss';
import {
	TableContainer,
	Table,
	TableHead,
	TableCell,
	TableRow,
	TableBody,
	TablePagination,
	IconButton,
	Paper
} from '@mui/material';
import { getListaVacantesPostuladas } from '../../modules/apps/user-management/users-list/core/_requests';
import { useAuth } from '../../modules/auth';
import { LinearLoadingSpinner, LoadingBackdrop } from '../../components/LoadingSpinner/LoadingSpinner';
import BackButton from '../../components/BackButton/BackButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import LastPageIcon from '@mui/icons-material/LastPage';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

const EmployerRequestedCandidatoPostularPage = () => {

	const { currentUser, } = useAuth();
	const [data, setData]: any[] = useState([]);
	const [userData, setUserData]: any[] = useState([]);
	const [total, setTotal] = useState<number>(0);
	const [totalPage, setTotalPage] = useState<number>(0);
	const [filter, setFilter] = useState<any>({
		page: 1,
		limit: 10,
		estado: '',
		autoPostulacion: null,
	});
	const [loading, setLoading] = useState(false);
	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(10);
	const [requestInProgress, setRequestInProgress] = useState(false);
	const [open, setOpen] = useState(false);


	const handleChangePage = (newPage: any) => {
		const newPageNumber = parseInt(newPage) + 1;
		const f = { ...filter, page: newPageNumber };
		setPage(newPage);
		setFilter(f);
	};

	const handleChangeRowsPerPage = (event: any) => {
		const f = { ...filter, page: 1, limit: parseInt(event.target.value, 10) }
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
		setFilter(f);
	};
	const handleFirstPageButtonClick = () => {
		handleChangePage(0);
	};

	const handleLastPageButtonClick = () => {
		handleChangePage(Math.ceil(total / rowsPerPage) - 1);
	};
	useEffect(() => {
		setUserData({ ...userData, id_users: currentUser?.user?.id });
	}, []);

	useEffect(() => {
		handleSubmit();
	}, [filter]);

	const changePaginate = (pf: any) => {
		const f = { page: pf.page, limit: pf.limit };
		setFilter(f);
	};
	const handleClose = () => {
		setOpen(false);
	};


	// const handleSubmit = async () => {
	// 	setLoading(true);
	// 	try {
	// 		const response = await getListaVacantesPostuladas()
	// 		if (response && response.data) {
	// 			setTotal(response.data.total);
	// 			setTotalPage(response.data.totalPages);
	// 			setData(response.data.data);
	// 		}

	// 	} catch (error: any) {
	// 		if (error.response) {
	// 			console.error(error.response.data.error);
	// 		} else {
	// 			console.error('Ocurrio un error procesando la solicitud.');
	// 		}
	// 	} finally {
	// 		setLoading(false);
	// 	}
	// };

	const handleSubmit = async () => {
		setLoading(true);
		try {
		  const params = {
			page: filter.page,
			limit: filter.limit,
			// otros parámetros que necesites
		  };
		  
		  const response = await getListaVacantesPostuladas(params);
		  if (response && response.data) {
			setTotal(response.data.total);
			setTotalPage(response.data.totalPages);
			setData(response.data.data);
		  }
		} catch (error: any) {
		  if (error.response) {
			console.error(error.response.data.error);
		  } else {
			console.error('Ocurrio un error procesando la solicitud.');
		  }
		} finally {
		  setLoading(false);
		}
	  };

	return (
		<>
			<div className='p-4 shadow-4 rounded-3 mt-15' style={{ backgroundColor: '#FFFF' }}>
				<LoadingBackdrop loading={requestInProgress} />
				<div className='row mb-6'>
					<div className='col-12'>
						<div className='input-group d-flex' style={{ width: '100%' }}>
							<div style={{ padding: '10px 0px 0px 0px' }}>
								<div className='col-xs-2 col-sm-1 col-md-1'
									style={{
										display: 'contents',
										justifyContent: 'center',
										alignItems: 'center'
									}} >
									<BackButton />
								</div>
							</div>

						</div>
					</div>
				</div>
				{loading && <LinearLoadingSpinner isLoading={loading} />}
				{data.lenght !== 0 && (
					<TableContainer component={Paper}>
						<Table className={`table table-responsive table-striped`}>

							<TableHead className={`${styleScss['th-custom']}`}>
								<TableRow>
									<TableCell style={{ fontFamily: 'Poppins', fontSize: '16.25px', textAlign: 'center', paddingLeft: '8px' }}>
										<h4>Código</h4>
									</TableCell>
									<TableCell style={{ fontFamily: 'Poppins', fontSize: '16.25px', textAlign: 'center', paddingLeft: '8px' }}>
										<h4>Nombre de la vacante</h4>
									</TableCell>
									<TableCell style={{ fontFamily: 'Poppins', fontSize: '16.25px', textAlign: 'center' }}>
										<h4>Empresa</h4>
									</TableCell>
									<TableCell style={{ fontFamily: 'Poppins', fontSize: '16.25px', textAlign: 'center' }}>
										<h4>Consejero Empleador</h4>
									</TableCell>
									<TableCell
										style={{
											fontFamily: 'Poppins',
											fontSize: '16.25px',
											textAlign: 'center',
											width: '180px',       
											minWidth: '180px',    
											maxWidth: '180px',   
											
										}}
									>
										<h4>Número de auto postulados con estado presentado</h4>
									</TableCell>

								</TableRow>
							</TableHead>

							<TableBody>
								{!loading && data.map((x: any, i: any) => (
									<TableRow key={i} id={i.toString()}>

										<TableCell style={{ fontFamily: 'Poppins', fontSize: '14.5px', overflowWrap: 'break-word', textAlign: 'center' }} className='pt-3 pb-3' scope='row'>
											{x?.codigo_vacante}
										</TableCell>
										<TableCell style={{ fontFamily: 'Poppins', fontSize: '14.5px', overflowWrap: 'break-word', wordBreak: 'break-all', textAlign: 'center' }}>{x?.nombre_vacante}</TableCell>
										<TableCell style={{ fontFamily: 'Poppins', fontSize: '14.5px', overflowWrap: 'break-word', wordBreak: 'break-all', textAlign: 'center' }}>{x?.Empresa?.razon_social}</TableCell>
										<TableCell style={{ fontFamily: 'Poppins', fontSize: '14.5px', overflowWrap: 'break-word', wordBreak: 'break-all', textAlign: 'center' }}>{x.CreatedBy?.UserComplemento?.nombre_completo}</TableCell>
										<TableCell
											style={{
												fontFamily: 'Poppins',
												fontSize: '14.5px',
												textAlign: 'center',
												width: '180px',      // Mismo ancho que el encabezado
												minWidth: '180px',
												maxWidth: '180px',
												overflowWrap: 'break-word'
											}}
										>
											{x?.CurriculoVagaEmpresas?.length || 0}
										</TableCell>
									</TableRow>
								))}
							</TableBody>

							{data.length === 0 && (
								<tfoot>
									<TableRow>
										<TableCell colSpan={5}>
											<p className='text-center' style={{ width: '100%', textAlign: 'center' }}>
												No se encontraron registros
											</p>
										</TableCell>
									</TableRow>
								</tfoot>
							)}
						</Table>
						<div style={{ fontFamily: 'Poppins', fontSize: '14.5px' }}>
							<TablePagination
								rowsPerPageOptions={[10, 20, 50, 100]}
								component="div"
								style={{ overflow: 'visible', fontFamily: 'Poppins', fontSize: '14.5px' }}
								count={total}
								rowsPerPage={rowsPerPage}
								page={page}
								onPageChange={(event, newPage) => handleChangePage(newPage)}
								onRowsPerPageChange={handleChangeRowsPerPage}
								labelRowsPerPage="Filas por página:"
								labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
								ActionsComponent={({ onPageChange, page: number, count, rowsPerPage }) => (
									<div style={{ display: 'flex', alignItems: 'center', fontFamily: 'Poppins', fontSize: '14.5px' }}>
										<IconButton onClick={handleFirstPageButtonClick} disabled={page === 0} aria-label="first page">
											<FirstPageIcon />
										</IconButton>
										<IconButton onClick={(event) => onPageChange(event, page - 1)} disabled={page === 0} aria-label="previous page">
											<ChevronLeftIcon />
										</IconButton>
										<IconButton onClick={(event) => onPageChange(event, page + 1)} disabled={page >= Math.ceil(count / rowsPerPage) - 1} aria-label="next page">
											<ChevronRightIcon />
										</IconButton>
										<IconButton onClick={handleLastPageButtonClick} disabled={page >= Math.ceil(count / rowsPerPage) - 1} aria-label="last page">
											<LastPageIcon />
										</IconButton>
									</div>
								)}
							/>
						</div>
					</TableContainer>
				)}
				
			</div>
		</>
	);
};

const ConsejeroCandidatoVacantesPostuladosWrapper = () => {
	return (
		<>
			<PageTitle breadcrumbs={[]}>Gestión de candidatos (Autopostulación)</PageTitle>
			<EmployerRequestedCandidatoPostularPage />
		</>
	);
};

export { ConsejeroCandidatoVacantesPostuladosWrapper };
 





